import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function setCookie(name: string, value: string, days = 365) {
  if (typeof document === 'undefined') return;
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = "; expires=" + date.toUTCString();
  document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax";
}

export function getCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export function isProductPath(pathname: string): boolean {
  if (!pathname) return false;
  const clean = pathname.split('?')[0].split('#')[0];
  return (
    clean === '/products' ||
    clean.startsWith('/products/') ||
    clean === '/nova' ||
    clean.startsWith('/nova/') ||
    clean === '/nova-workspace' ||
    clean.startsWith('/nova-workspace/') ||
    clean === '/nova-cartograph' ||
    clean.startsWith('/nova-cartograph/') ||
    clean === '/croplens' ||
    clean.startsWith('/croplens/') ||
    clean === '/agroscore' ||
    clean.startsWith('/agroscore/') ||
    clean === '/droughtwatch' ||
    clean.startsWith('/droughtwatch/') ||
    clean === '/ai' ||
    clean.startsWith('/ai/') ||
    clean === '/geoai' ||
    clean.startsWith('/geoai/')
  );
}

export function getLocalizedPath(path: string, lang: 'en' | 'ar'): string {
  if (!path || path.startsWith('http') || path.startsWith('#') || path.startsWith('mailto:')) {
    return path;
  }
  // Product paths are never prefixed with /ar
  if (isProductPath(path)) {
    if (path === '/ar') return '/';
    if (path.startsWith('/ar/')) return path.replace(/^\/ar/, '') || '/';
    return path;
  }

  if (lang === 'ar') {
    if (path === '/' || path === '') return '/ar';
    if (path === '/ar' || path.startsWith('/ar/')) return path;
    return `/ar${path.startsWith('/') ? path : '/' + path}`;
  } else {
    // English
    if (path === '/ar' || path === '/ar/') return '/';
    if (path.startsWith('/ar/')) return path.replace(/^\/ar/, '') || '/';
    return path;
  }
}

